<template>
    <div class="list-with-spinner">
        <bounce-spinner v-if="processing"></bounce-spinner>
        <slot></slot>
    </div>
</template>

<script>
  import BounceSpinner from './Spinner/BounceSpinner';

  export default {
    props: {
      processing: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    components: {
      BounceSpinner
    }
  }
</script>

<style>
    .list-with-spinner {
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListWithSpinner.vue